import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateValetListData, getSupervisorListData, updateSupervisorListData } from "services/redux/Valet/Supervisor/action";
import SuperVisorSalaryPromotion from "./SalaryPromotion";

const mapStateToProps = (state) => ({
    updateValetListData: state.CreateSupervisor.updateValetListData,
    valetListData: state.CreateSupervisor.valetListData,
    supervisorListData: state.CreateSupervisor.supervisorListData
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        updateValetListData,
        getSupervisorListData,
        updateSupervisorListData
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SuperVisorSalaryPromotion);
